<template>
  <s-section
    type="inverse"
    class="call-to-action"
  >
    <div class="row">
      <div class="col-lg-9 ml-auto">
        <div
          class="section__header"
          :class="{'mb-0': !hasDefaultSlot}"
        >
          <h2
            v-if="title"
            class="section__title"
            v-html="title"
          ></h2>
          <div
            v-if="description"
            class="section__subtitle call-to-action__description"
            v-html="description"
          ></div>
        </div>
        <div
          v-if="hasDefaultSlot"
          class="call-to-action__button"
        >
          <slot></slot>
        </div>
      </div>
    </div>
  </s-section>
</template>

<script>
export default {
  name: 'CallToAction',
  props: {
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    }
  },
  computed: {
    hasDefaultSlot() {
      return !!this.$slots.default
    }
  }
}
</script>

<style lang="scss">
.call-to-action {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.call-to-action__description {
  a {
    color: #FFF;
    text-decoration: underline;
  }
}

.call-to-action__button {
  @media (max-width: $breakpoint-sm) {
    text-align: center;
  }
}

.call-to-action__button .btn {
  @media (max-width: $breakpoint-sm) {
    width: 100%;
  }
}
</style>